export function getReports() {
  try {
    const raw = localStorage.getItem("reportsInProgress");
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function saveReports(reports) {
  try {
    localStorage.setItem("reportsInProgress", JSON.stringify(reports));
    return true;
  } catch (e) {
    if (e.name === "QuotaExceededError") {
      const trimmed = reports.slice(-5);
      try {
        localStorage.setItem("reportsInProgress", JSON.stringify(trimmed));
        return true;
      } catch {
        console.warn("localStorage full, could not save report progress.");
        return false;
      }
    } else {
      throw e;
    }
  }
}

export function upsertReport(report) {
  const reports = getReports();
  const idx = reports.findIndex((r) => r.id === report.id);
  if (idx >= 0) reports[idx] = report;
  else reports.push(report);
  return saveReports(reports);
}

export function deleteReport(id) {
  saveReports(getReports().filter((r) => r.id !== id));
}

export function markReportUploadStatus(id, uploadStatus) {
  const reports = getReports();
  const idx = reports.findIndex((r) => r.id === id);
  if (idx >= 0) {
    reports[idx] = { ...reports[idx], uploadStatus };
    saveReports(reports);
  }
}

export function loadReportIntoSession(report) {
  if (report.anonymityData)   sessionStorage.setItem("anonymityData",   JSON.stringify(report.anonymityData));
  if (report.reportImageData) sessionStorage.setItem("reportImageData", JSON.stringify(report.reportImageData));
  if (report.fishInfoData)    sessionStorage.setItem("fishInfoData",     JSON.stringify(report.fishInfoData));
  sessionStorage.setItem("activeReportId", report.id);
}

export function snapshotCurrentReport(existingId, imagesMeta) {
  function parse(key) {
    try { const r = sessionStorage.getItem(key); return r ? JSON.parse(r) : null; } catch { return null; }
  }

  // Strip preview (base64 image data) and large per-image fields before
  // storing in localStorage — images live in IndexedDB, not here.
  const safeMeta = (imagesMeta || []).map(({ preview, cameraLocation, cameraDatetime, ...rest }) => rest);

  return {
    id:              existingId || `report-${Date.now()}-${Math.random().toString(36).slice(2)}`,
    anonymityData:   parse("anonymityData"),
    reportImageData: parse("reportImageData"),
    fishInfoData:    parse("fishInfoData"),
    imagesMeta:      safeMeta,
    uploadStatus:    null,
  };
}

export function getReportLabel(report) {
  const dateStr = report.reportImageData?.dateTaken;
  const tagId   = report.fishInfoData?.tagPrefix && report.fishInfoData?.tagNumber
    ? `${report.fishInfoData.tagPrefix}${report.fishInfoData.tagNumber}`
    : null;
  if (dateStr) {
    const [y, m, d] = dateStr.split("-");
    const formatted = new Date(Number(y), Number(m) - 1, Number(d))
      .toLocaleDateString(undefined, { month: "short", day: "numeric" });
    return tagId ? `${formatted} · ${tagId}` : formatted;
  }
  return "Report in Progress";
}